<script lang="ts">
  export let href: string | undefined = undefined
  export let onClick: (e: KeyboardEvent | MouseEvent) => void = () => {}
</script>

<a class="au-link" {href} on:click={onClick} {...$$restProps}><slot /></a>

<style>
  .au-link {
    color: var(--au-text-color-link);
    text-decoration: none;
  }

  .au-link:hover {
    text-decoration: underline;
  }

  .au-link:focus-visible {
    outline-offset: 2px;
  }
</style>
